var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterSpacing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 15,
    viewBox: "0 0 11.044 15.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30618",
    "data-name": "Group 30618",
    transform: "translate(-52.024 -113.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50124",
    "data-name": "Path 50124",
    d: "M59.7,125.473H55.388a1.278,1.278,0,0,1,0-2.555h.881v-6.473h-1.69v.7a1.277,1.277,0,1,1-2.555,0v-1.981a1.279,1.279,0,0,1,1.277-1.278h8.49a1.279,1.279,0,0,1,1.277,1.278v1.981a1.277,1.277,0,1,1-2.555,0v-.7h-1.69v6.473h.88a1.278,1.278,0,1,1,0,2.555Zm-4.316-1.935a.658.658,0,1,0,0,1.315H59.7a.658.658,0,1,0,0-1.315H58.514a.31.31,0,0,1-.31-.31v-7.094a.31.31,0,0,1,.31-.31h2.31a.31.31,0,0,1,.31.31v1.013a.658.658,0,0,0,1.315,0v-1.981a.658.658,0,0,0-.658-.658H53.3a.658.658,0,0,0-.657.658v1.981a.657.657,0,1,0,1.315,0v-1.013a.31.31,0,0,1,.31-.31h2.31a.31.31,0,0,1,.31.31v7.094a.31.31,0,0,1-.31.31Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30617",
    "data-name": "Group 30617",
    transform: "translate(52.024 125.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50125",
    "data-name": "Path 50125",
    d: "M62.758,154.7H52.334a.31.31,0,1,1,0-.62H62.758a.31.31,0,1,1,0,.62Z",
    transform: "translate(-52.024 -152.635)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50126",
    "data-name": "Path 50126",
    d: "M53.769,153.249a.309.309,0,0,1-.219-.091l-1.436-1.436a.31.31,0,0,1,0-.438l1.436-1.435a.31.31,0,0,1,.438.438L52.772,151.5l1.216,1.217a.31.31,0,0,1-.219.529Z",
    transform: "translate(-52.024 -149.758)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50127",
    "data-name": "Path 50127",
    d: "M79.184,153.249a.31.31,0,0,1-.219-.529l1.216-1.217-1.216-1.216a.31.31,0,0,1,.438-.438l1.436,1.435a.31.31,0,0,1,0,.438L79.4,153.158A.308.308,0,0,1,79.184,153.249Z",
    transform: "translate(-69.885 -149.758)",
    fill: "#333"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterSpacing);
export default __webpack_public_path__ + "static/media/letterSpacing.544f6244.svg";
export { ForwardRef as ReactComponent };